import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Opportunity } from './components/Opportunity';
import { FuturePacing } from './components/FuturePacing';
import { Story } from './components/Story';
import { Proof } from './components/Proof';
import { Testimonials } from './components/Testimonials';
import { VideoExamples } from './components/VideoExamples';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesNotification } from './components/SalesNotification';
import { FlashBanner } from './components/FlashBanner';
import { FloatingBuyButton } from './components/FloatingBuyButton';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900" data-id="element-0">
      <FlashBanner data-id="element-1" />
      <FloatingBuyButton data-id="element-2" />
      <div className="pt-12 md:pt-14" data-id="element-3">
        <SalesNotification data-id="element-4" />
        <Hero data-id="element-5" />
        <Problem data-id="element-6" />
        <Opportunity data-id="element-7" />
        <FuturePacing data-id="element-8" />
        <Story data-id="element-9" />
        <Proof data-id="element-10" />
        <Testimonials data-id="element-11" />
        <VideoExamples data-id="element-12" />
        <ProductBreakdown data-id="element-13" />
        <Guarantee data-id="element-14" />
        <Urgency data-id="element-15" />
        <FinalCTA data-id="element-16" />
        <Footer data-id="element-17" />
      </div>
    </div>;
}